import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the PardotVerify state domain
 */

const selectPardotVerifyDomain = state => state.pardotVerify || initialState;

/**
 * Other specific selectors
 */

const makeSelectIsVerify = () =>
  createSelector(selectPardotVerifyDomain, subState => subState.isVerify);

const makeSelectError = () => createSelector(selectPardotVerifyDomain, subState => subState.error);

export { makeSelectIsVerify, makeSelectError };
